export default {
  text: "We’re setting up your table 🍽…",
};
